import serviceType from 'constants/serviceType';
import axiosClient from './aixosClient';
import { AxiosResponse } from 'axios';
import { BaseResponse } from 'models/baseResponse';
const game3rdApi = {
    initTransfer(payload: { action?: string }): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = 'Transfer_init';
        return axiosClient.post(serviceType.GA_SERVICE, payload);
    },
    checkBalance(payload: { action: string; isLoad?: string }): Promise<AxiosResponse<BaseResponse<any>>> {
        return axiosClient.post(serviceType.GA_SERVICE, payload);
    },

    sysGame3rdLoginBean(payload: any): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = 'loginEntry3rdGame';
        return axiosClient.post(serviceType.GA_SERVICE, payload);
    },

    Login3RD(payload: any): Promise<AxiosResponse<BaseResponse<any>>> {
        return axiosClient.post(serviceType.GA_SERVICE, payload);
	},

    LoginSlot(payload = {}): Promise<AxiosResponse<BaseResponse<any>>> {
        return axiosClient.post(serviceType.GA_SERVICE, payload);
	},

    OpenTDGame(payload: any): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = 'tdLogin_getLobbyLink';
        return axiosClient.post(serviceType.GA_SERVICE, payload);
	},

    submitTransfer(payload: any): Promise<AxiosResponse<BaseResponse<any>>> {
        return axiosClient.post(serviceType.GA_SERVICE, payload);
    },
};
export default game3rdApi;
